import ApiKeysPage from '../pages/dashboard/components/pages/apikeys/ApiKeysPage';

export default function ApiKeysRoute() {
  return <ApiKeysPage />;
}
